// extracted by mini-css-extract-plugin
export default {"politicaDeprivacidade":"TextoPoliticaDePrivacidade_politicaDeprivacidade__Ua1vQ"};